module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/4.3-update-store.be546016.png";